import Instance from '../../../../Axios';

const AdicionarItemLimpeza = (ydata) => async (dispatch) => {
  console.log(ydata);
  await Instance()
    .post('/backend/checklist/itens', { ydata })
    .then(({ data }) => {
      console.log(data);
      dispatch({ type: 'POST_ITEM_LIMPEZAS', payload: data });
      //   show('success', 'Foram associados novos funcionários á obra');
    })
    .catch((err) => {
      // eslint-disable-next-line eqeqeq
      if (err.response.status != 200) {
        // show('warning', 'Preencha todos os campos');
      }
    });
};

export default AdicionarItemLimpeza;
